
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>

<div class="giga-login">
    <div class="row">
      <div class="col-lg-6">
        <div class="giga-login_wrapper">
          <div class="giga-login_form">
            <h2 class="giga-login_title">{{$t('find_account')}}</h2>

            <form role="form" v-on:submit.prevent="requestReset">
              <div class="giga-fields">
                <!-- EMAIL -->
                <div
                  class="giga-input_field full-field"
                  :class="{'field-hasError' : $v.resetAccount.email.$anyDirty && $v.resetAccount.email.$invalid }"
                >
                  <label class="input-field_label">{{$t('enter_your_email')}}</label>
                  <div class="input-field_area">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      v-model="$v.resetAccount.email.$model"
                      required
                      email
                      data-cy="emailResetPassword"
                    />
                  </div>
                  <div class="giga-login_errors" v-if="$v.resetAccount.email.$anyDirty && $v.resetAccount.email.$invalid">
                    <ul class="login-errors_list">
                      <li class="error-item" v-if="!$v.resetAccount.email.email">{{ $t("email_nvalid") }}</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="giga-form_footer">
                <div class="giga-button">
                  <button
                    class="giga-green_button no-icon"
                    type="submit"
                    :disabled="$v.resetAccount.$invalid"
                    data-cy="submit"
                  >
                    <b-spinner variant="light" small  class="mr-2 align-middle" v-if="loading"></b-spinner>
                    <span v-if="!loading"> {{$t('soumettre')}} </span>
                  </button>
                </div>
                <div class="giga-button giga-flex_center">
                  <b-button to="/login" class="giga-no_bg_button">
                    <i class="back-icon">
                      <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.9231 6.5L1.84617 6.5" stroke="#132D48" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6.5 1L1 6.5L6.5 12" stroke="#132D48" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </i>  
                    <span>Se connecter</span>
                  </b-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="row">
          <div class="giga-login_content">
          <div class="giga-login_content_box">
            <img src="@/assets/images/Gigawhat_Official_Logo.svg" alt="">
            <h2>Plateforme 360° de gestion des CEE</h2>
            <p>Découvrez la plateforme la plus complète du marché: création d'opérations, simulation de volumes, veille règlementaire, facturation en ligne.</p>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { email, required } from 'vuelidate/lib/validators';
import { loginService, accountService } from './services';
import vueRouter from '@/plugins/vue-router';
import {mapActions} from 'vuex';
import eventBus from '@/shared/event.bus';

const DEFAULT_MODAL_NOTIFICATION = 'default-modal-notification';

export default {
  name: 'ForgetPassword',
  components: {},
  props: [],
  mounted() {
    eventBus.$on('okClick', () => {
      this.closeModal({instance: this.$root, id: DEFAULT_MODAL_NOTIFICATION})
      vueRouter.router.push('/login', Function)
    })
    eventBus.$on('closeClick', () => {
      this.closeModal({instance: this.$root, id: DEFAULT_MODAL_NOTIFICATION})
      vueRouter.router.push('/login', Function)
    })
  },
  data() {
    return {
      resetAccount: {
        email: null,
      },
      notificationContent: null,
      loading: false,
    };
  },
  methods: {
    ...mapActions('notification', ['openModal', 'closeModal']),
    requestReset() {
      this.loading = true;
      loginService.requestResetPassword(this.resetAccount.email).then().finally(() => vueRouter.router.push('/email-verification', Function));
    },
    // showModal() {
    //   this.notificationContent = `${this.$tc('sent_regenerate_password' , `<strong>${this.resetAccount.email}</strong>`)}`
    //   const data = {
    //     id: DEFAULT_MODAL_NOTIFICATION,
    //     backdropClose: false,
    //     content: this.notificationContent,
    //     fontSize: 'h4',
    //     instance: this.$root
    //   };
    //   this.loading = false;
    //   this.openModal(data)
    // },
  },
  validations: {
    resetAccount: {
      email: {
        required,
        email,
      },
    },
  },
  computed: {},
  watch: {
    $route() {
      accountService.hideForgetPasswordModal(this.$root);
    },
  },
  beforeDestroy() {
    eventBus.$off('okClick');
    eventBus.$off('closeClick');
  }
};
</script>
